module.exports = __webpack_public_path__ + "static/img/banner-bg.83fa5c63.png";